export default __webpack_public_path__ + "5d84770f61d47c7399a7be5e52386aef.png";